import { render, staticRenderFns } from "./SCookieBanner.vue?vue&type=template&id=651dab6e&scoped=true"
import script from "./sCookieBanner.ts?vue&type=script&lang=ts&external"
export * from "./sCookieBanner.ts?vue&type=script&lang=ts&external"
import style0 from "./SCookieBanner.vue?vue&type=style&index=0&id=651dab6e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651dab6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('651dab6e')) {
      api.createRecord('651dab6e', component.options)
    } else {
      api.reload('651dab6e', component.options)
    }
    module.hot.accept("./SCookieBanner.vue?vue&type=template&id=651dab6e&scoped=true", function () {
      api.rerender('651dab6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-cookie-banner/SCookieBanner.vue"
export default component.exports